import { env } from 'utils/envManager'

export const MY_PURCHASES_BASE_URL = `${env.NEXT_PUBLIC_SITE_BASE_URL}/ws-my-purchases`
export const MY_PURCHASES_V2 = `${MY_PURCHASES_BASE_URL}/v2`
export const PURCHASE_DETAIL_URL = `${MY_PURCHASES_V2}/purchases`
export const GUEST_ONLINE_DETAILS_URL = `${PURCHASE_DETAIL_URL}/online/order`
export const PURCHASE_STATUS_URL = `${PURCHASE_DETAIL_URL}/online`
export const RETURNS_BASE_URL = `${env.NEXT_PUBLIC_SITE_BASE_URL}/ws-returns`
